(() => {
  const images = {
    timber: 'https://cdn.shopify.com/s/files/1/0947/3130/5226/files/Doors_Access_Supplies_Timber_Doors.png?v=1791134789',
    aluminium: 'https://cdn.shopify.com/s/files/1/0947/3130/5226/files/Door_Access_Supplies_Fully_Glazed_Doors.png?v=1791134869',
    glass: 'https://cdn.shopify.com/s/files/1/0947/3130/5226/files/Door_Access_Supplies_Glass_Doors.png?v=1791134748',
    gate: 'https://cdn.shopify.com/s/files/1/0947/3130/5226/files/Gated_Entrance_and_Exit_Signage.png?v=1791471181'
  };
  const names = {
    maglocks: 'Maglocks', 'shearlocks-bolts': 'Shear locks & bolts', 'electric-strikes': 'Electric strikes',
    'key-pads': 'Keypads & readers', 'push-buttons-and-domes': 'Exit buttons',
    'break-glass-call-points': 'Emergency releases', psus: 'Power supplies', batteries: 'Batteries', relays: 'Relays',
    'maglock-brackets-and-accessories': 'Maglock brackets', 'lockable-boxes': 'Enclosures', 'push-button-accessories': 'Accessories', 'door-loops': 'Door Loops'
  };
  const componentNames = {
    psu: { marker: 'PSU', list: 'PSU' }, lock: { marker: 'Lock', list: 'Lock' }, strike: { marker: 'Strike', list: 'Strike' },
    reader: { marker: 'Keypad/Reader', list: 'Keypad / Reader' }, exit: { marker: 'Exit', list: 'Exit Button' },
    release: { marker: 'Breakglass', list: 'Breakglass' }, bracket: { marker: 'Bracket', list: 'Maglock Brackets' },
    'glass-accessories': { marker: 'Glass Brkt', list: 'Glass Door Bracket' }, battery: { marker: 'Battery', list: 'Battery' },
    relay: { marker: 'Relay', list: 'Relay' }, enclosure: { marker: 'Enclosure', list: 'Enclosure' }
  };
  const point = (key, label, x, y, ranges, environment = 'internal') => ({ key, label, x, y, ranges, environment });
  const shared = [
    point('psu', 'Power supply', 59, 15, ['psus']), point('exit', 'Exit button', 59, 43, ['push-buttons-and-domes']),
    point('release', 'Emergency release', 59, 56, ['break-glass-call-points']),
    point('reader', 'Keypad or reader', 43, 58, ['key-pads'], 'exterior')
  ];
  const recommendations = {
    timber: { lock: ['ml600-m'], reader: ['kpx1000'], exit: ['stainless-steel-press-to-exit-green-dome-inc-surround'], psu: ['1202sm-1'], release: ['edr-2n'], strike: ['as900'], bracket: { push: ['adj-600l'], pull: ['ab600zl-dc'] } },
    aluminium: { lock: ['ml600-m'], reader: ['kpx1000'], exit: ['stainless-steel-press-to-exit-green-dome-inc-surround'], psu: ['1202sm-1'], release: ['edr-2n'], strike: ['as900'], bracket: { push: ['adj-600l'], pull: ['ab600zl-dc'] } },
    glass: { lock: ['ml600-m'], reader: ['kpx1000'], exit: ['stainless-steel-press-to-exit-green-dome-inc-surround'], psu: ['1202sm-1'], release: ['edr-2n'], 'glass-accessories': { push: ['bk600u', 'adj-600l'], pull: ['gd600zl-ab'] } },
    gate: { lock: ['exml600-gate'], reader: ['kpx50'], exit: ['stainless-steel-press-to-exit-green-dome-ip66'], psu: ['1202sm-1'], release: ['wp-edr-2'], bracket: { pull: ['bkex600zl'] } }
  };
  const scenes = {
    timber: { label: 'Timber door', points: [...shared, point('lock', 'Maglock or bolt', 36, 23, ['maglocks', 'shearlocks-bolts']), point('strike', 'Electric strike', 37, 49, ['electric-strikes']), { ...point('bracket', 'Maglock brackets', 36, 31, ['maglock-brackets-and-accessories']), requiresLock: 'maglocks' }] },
    aluminium: { label: 'Aluminium door', points: [...shared.map(p => p.key === 'reader' ? { ...p, y: 50 } : p), point('lock', 'Maglock or bolt', 36, 23, ['maglocks', 'shearlocks-bolts']), point('strike', 'Electric strike', 37, 43, ['electric-strikes']), { ...point('bracket', 'Maglock brackets', 36, 31, ['maglock-brackets-and-accessories']), requiresLock: 'maglocks' }] },
    glass: { label: 'Glass door', points: [...shared, point('lock', 'Choose a lock', 37, 22, ['maglocks', 'shearlocks-bolts']), { ...point('glass-accessories', 'Glass door accessories', 37, 30, ['maglock-brackets-and-accessories']), requiresGlassLock: true }] },
    gate: { label: 'Gate', points: [point('psu', 'Power supply', 95, 37, ['psus']), point('lock', 'Choose a lock', 62, 39, ['maglocks', 'shearlocks-bolts', 'electric-strikes']), { ...point('bracket', 'Maglock brackets', 62, 43, ['maglock-brackets-and-accessories']), requiresLock: 'maglocks' }, point('reader', 'Entry reader', 11, 53, ['key-pads']), point('exit', 'Exit button', 95, 63, ['push-buttons-and-domes']), point('release', 'Emergency release', 95, 71, ['break-glass-call-points'])] }
  };
  const extras = [
    point('battery', 'Batteries', 0, 0, ['batteries']), point('relay', 'Relays & reducers', 0, 0, ['relays']),
    point('enclosure', 'Enclosures', 0, 0, ['lockable-boxes']), point('accessories', 'Accessories', 0, 0, ['push-button-accessories']),
    point('door-loops', 'Door Loops', 0, 0, ['door-loops'])
  ];
  const excludedBreakglassHandles = new Set(['b-mcp-2n', 'o-mcp-2n', 'sv-mcp-2n']);
  const cache = new Map();
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = value;
    return element;
  };
  const loadRange = async (handle) => {
    if (!cache.has(handle)) cache.set(handle, (async () => {
      let page = 1, products = [];
      while (page && page < 25) {
        const url = new URL('/collections/' + encodeURIComponent(handle), location.origin);
        url.searchParams.set('view', 'das-builder-feed');
        url.searchParams.set('page', String(page));
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        // Shopify collection views can return a different JSON representation
        // when this header is present. Let the `view` query parameter select
        // the builder feed template and parse its JSON response as-is.
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Products could not be loaded (request returned ' + response.status + ').');
        const data = await response.json().catch(() => null);
        if (!data) throw new Error('The product feed did not return JSON.');
        if (!Array.isArray(data.products)) throw new Error('The product list is unavailable.');
        products = products.concat(data.products);
        page = data.next_page;
      }
      return products;
    })().catch(error => { cache.delete(handle); throw error; }));
    return cache.get(handle);
  };
  const glassAccessoriesForLock = (lock, accessoryProducts) => {
    const extractCodes = value => [...(value || '').matchAll(/(^|[^a-z0-9-])((?:mbk-)?(?:ml\d{3,4}(?:-[a-z0-9]+)*|msl-\d{4}|1354-\d{4}))(?=$|[^a-z0-9-])/gi)].map(match => match[2].toLowerCase());
    const lockCodes = new Set(extractCodes(lock.title));
    return accessoryProducts.filter(product => {
      const type = (product.product_type || '').toLowerCase();
      const text = ((product.title || '') + ' ' + (product.description || '')).toLowerCase();
      const compatibilityText = (product.description || '').match(/compatible (?:maglocks|products?)\s*:?\s*([\s\S]*)/i)?.[1] || product.description || '';
      const accessoryCodes = extractCodes(compatibilityText);
      return type.includes('accessor') && text.includes('glass') && (product.variants || []).some(variant => variant.available) && accessoryCodes.some(code => lockCodes.has(code));
    }).map(product => product.handle);
  };
  const bracketFamily = product => {
    const text = ((product.title || '') + ' ' + (product.handle || '') + ' ' + (product.description || '')).toLowerCase();
    if (/z\s*(?:&|and)\s*l|(?:zl|zle)(?:\b|[-/])|z-l/.test(text)) return 'pull';
    if (/\bl\s*bracket|\badjustable l\b|\bl cover\b|f\s*&\s*l/.test(text)) return 'push';
    if (/\bglass u\b|\bu bracket\b/.test(text)) return 'shared';
    return 'shared';
  };
  const accessoriesForLock = (lock, accessoryProducts) => {
    const extractCodes = value => [...(value || '').matchAll(/(^|[^a-z0-9-])((?:mbk-)?(?:ml\d{3,4}(?:-[a-z0-9]+)*|msl-\d{4}|1354-\d{4}))(?=$|[^a-z0-9-])/gi)].map(match => match[2].toLowerCase());
    const lockCodes = new Set(extractCodes(lock.title));
    return accessoryProducts.filter(product => {
      const type = (product.product_type || '').toLowerCase();
      const compatibilityText = (product.description || '').match(/compatible (?:maglocks|products?)\s*:?\s*([\s\S]*)/i)?.[1] || product.description || '';
      return type.includes('accessor') && (product.variants || []).some(variant => variant.available) && extractCodes(compatibilityText).some(code => lockCodes.has(code));
    });
  };
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = selector => root.querySelector(selector);
    const priceText = pence => new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(pence / 100);
    const say = message => { $('[data-status]').textContent = message; };
    let scene = 'timber', active = null, range = null, selected = [], doorAction = '', psuVoltage = '', psuCurrent = '';
    let doors = [{ id: 'door-1', name: 'Door 1', scene: 'timber', doorAction: '', manualOverrideConfirmed: false }];
    let activeDoorId = 'door-1';
    const currentDoor = () => doors.find(door => door.id === activeDoorId) || doors[0];
    const currentSelections = () => selected.filter(item => item.doorId === activeDoorId);
    const selectionsForDoor = doorId => selected.filter(item => item.doorId === doorId);
    const image = $('[data-scene-image]'), hotspots = $('[data-hotspots]'), positions = $('[data-positions]'), picker = $('[data-picker]'), extrasOptions = $('[data-extras-options]'), anySearch = $('[data-any-search]'), anyProducts = $('[data-any-products]'), anyStatus = $('[data-any-status]'), anyPagination = $('[data-any-pagination]'), emergencyConfirm = $('[data-emergency-confirm]'), emergencyConfirmWrap = $('[data-emergency-confirm-wrap]');

    const missingGlassBrackets = (doorId = activeDoorId) => {
    const door = doors.find(entry => entry.id === doorId);
    if ((door?.scene || scene) !== 'glass') return [];
    const doorItems = selectionsForDoor(doorId);
    return doorItems.filter(item => item.isLock && (item.glassAccessoryHandles || []).length).filter(lock =>
      doorItems.filter(item => item.isGlassAccessory && item.glassLockKey === lock.lockKey).reduce((sum, item) => sum + item.quantity, 0) < lock.quantity
    );
  };
  const renderChecklist = () => {
    const list = $('[data-checklist]');
    const status = $('[data-checklist-status]');
    if (!list || !status) return;
    list.replaceChildren();
    const doorItems = currentSelections();
    const chosenCount = doorItems.reduce((sum, item) => sum + item.quantity, 0);
    const missingBrackets = missingGlassBrackets(activeDoorId);
    const hasBreakglass = doorItems.some(item => item.rangeHandle === 'break-glass-call-points');
    const overrideConfirmed = hasBreakglass || Boolean(emergencyConfirm?.checked);
    const entries = [
      { label: 'Entrance', detail: scenes[scene].label + ' selected', state: 'complete' },
      doorAction
        ? { label: 'Opening direction', detail: (doorAction === 'push' ? 'Push' : 'Pull') + ' selected', state: 'complete' }
        : { label: 'Opening direction', detail: 'Choose Push or Pull first', state: 'required' },
      !hasBreakglass
        ? { label: 'Emergency safeguard', detail: emergencyConfirm?.checked ? 'Manual override confirmed' : 'Confirm this door has a manual override', state: emergencyConfirm?.checked ? 'complete' : 'required' }
        : { label: 'Emergency safeguard', detail: 'Breakglass selected', state: 'complete' }
    ];
    entries.forEach(entry => {
      const row = node('li', 'is-' + entry.state), copy = node('div', 'das-byo__checklist-copy');
      copy.append(node('strong', '', entry.label + ': '), node('span', '', entry.detail));
      row.append(copy);
      list.append(row);
    });
    const ready = chosenCount > 0 && Boolean(doorAction) && missingBrackets.length === 0 && overrideConfirmed;
    const allDoorsReady = doors.every(door => {
      const items = selectionsForDoor(door.id), hasRelease = items.some(item => item.rangeHandle === 'break-glass-call-points');
      return items.length > 0 && Boolean(door.doorAction) && missingGlassBrackets(door.id).length === 0 && (hasRelease || door.manualOverrideConfirmed);
    });
    const nextSteps = [];
    if (!doorAction) nextSteps.push('select Push or Pull');
    if (!chosenCount) nextSteps.push('add a component');
    if (missingBrackets.length) nextSteps.push('add the matching glass bracket' + (missingBrackets.length === 1 ? '' : 's'));
    if (!overrideConfirmed) nextSteps.push('confirm the manual override');
    status.textContent = !ready ? 'To continue, ' + nextSteps.join(' and ') + '.' :
      allDoorsReady ? 'All doors are ready to add to your basket or Project.' : 'This door is ready. Complete the other doors to continue.';
    status.classList.toggle('is-ready', allDoorsReady);
  };
  const renderComponentChecklist = () => {
    const list = $('[data-component-checklist]');
    if (!list) return;
    list.replaceChildren();
    const types = [
      { label: 'Power supply', ranges: ['psus'] },
      { label: 'Exit button', ranges: ['push-buttons-and-domes'] },
      { label: 'Breakglass', ranges: ['break-glass-call-points'] },
      { label: 'Keypad / reader', ranges: ['key-pads'] },
      { label: 'Lock (maglock / bolt)', ranges: ['maglocks', 'shearlocks-bolts'] },
      { label: 'Strike', ranges: ['electric-strikes'], unavailable: scene === 'glass' },
      ...extras.filter(extra => scene !== 'gate' || extra.key !== 'door-loops').map(extra => ({ label: names[extra.ranges[0]] || extra.label, ranges: extra.ranges }))
    ];
    if (scene === 'glass') types.push({ label: 'Glass-door bracket', glassBracket: true });
    else if (currentSelections().some(item => item.rangeHandle === 'maglocks')) types.push({ label: 'Maglock bracket', bracket: true });
    types.forEach(type => {
      let matches = [];
      if (type.glassBracket) matches = currentSelections().filter(item => item.isGlassAccessory);
      else if (type.bracket) matches = currentSelections().filter(item => item.isMaglockBracket && !item.isGlassAccessory);
      else matches = currentSelections().filter(item => type.ranges.includes(item.rangeHandle));
      let detail = 'Not selected', state = 'info';
      if (type.unavailable) detail = 'Not offered for glass doors';
      else if (matches.length) {
        const quantity = matches.reduce((sum, item) => sum + item.quantity, 0);
        detail = quantity + ' selected';
        state = 'complete';
      } else if (type.glassBracket) {
        const locks = currentSelections().filter(item => item.isLock && (item.glassAccessoryHandles || []).length);
        if (locks.length) {
          const missing = missingGlassBrackets();
          detail = missing.length
            ? 'Required for ' + missing.length + (missing.length === 1 ? ' selected lock' : ' selected locks')
            : 'Required brackets selected';
          state = missing.length ? 'required' : 'complete';
        } else detail = 'Required when a glass-door lock is selected';
      } else if (type.bracket) detail = 'Available for selected maglocks';
      const row = node('li', 'is-' + state), copy = node('div', 'das-byo__checklist-copy');
      copy.append(node('strong', '', type.label + ': '), node('span', '', detail));
      row.append(copy); list.append(row);
    });
  };
  const selectedView = () => {
      const doorItems = currentSelections();
      const hasBreakglass = doorItems.some(item => item.rangeHandle === 'break-glass-call-points');
      if (emergencyConfirmWrap) emergencyConfirmWrap.hidden = hasBreakglass;
      if (emergencyConfirm) {
        emergencyConfirm.required = !hasBreakglass;
        emergencyConfirm.setAttribute('aria-required', String(!hasBreakglass));
        if (hasBreakglass) currentDoor().manualOverrideConfirmed = false;
        emergencyConfirm.checked = hasBreakglass ? false : Boolean(currentDoor().manualOverrideConfirmed);
      }
      const list = $('[data-selected]'); list.replaceChildren();
      let count = 0, total = 0;
      selected.forEach(item => { count += item.quantity; total += item.quantity * item.price; });
      doors.forEach(door => {
        const doorItemsForSummary = selectionsForDoor(door.id);
        const grouped = new Map();
        doorItemsForSummary.forEach(item => {
          if (!grouped.has(item.position)) grouped.set(item.position, []);
          grouped.get(item.position).push(item);
        });
        grouped.forEach((items, position) => {
          const group = node('section', 'das-byo__selection-group');
          const direction = door.doorAction || '';
          const componentHeading = position.toLowerCase().includes('bracket') && direction
            ? position + ' · ' + (direction === 'push' ? 'Push / L brackets' : 'Pull / Z&L brackets')
            : position;
          group.append(node('h3', 'das-byo__selection-heading', door.name + ' · ' + componentHeading));
          items.forEach(item => {
            const row = node('div', 'das-byo__selection'), description = node('div'), controls = node('div', 'das-byo__selection-controls');
            description.append(node('strong', '', item.title + (item.variantTitle ? ' · ' + item.variantTitle : '')), node('small', '', (item.glassLockTitle ? 'For ' + item.glassLockTitle + ' · ' : item.bracketLockTitle ? 'Compatible with ' + item.bracketLockTitle + ' · ' : '') + priceText(item.price) + ' each'));
            if (item.isGlassAccessory) description.append(node('small', 'das-byo__compatibility-note', 'Required compatible glass-door bracket.'));
            if (door.scene === 'gate' && item.rangeHandle === 'psus') description.append(node('small', 'das-byo__compatibility-note', 'Covered gate location; large IP-rated enclosure suggested.'));
            const quantity = node('input'); quantity.type = 'number'; quantity.min = '1'; quantity.max = '99'; quantity.value = String(item.quantity); quantity.setAttribute('aria-label', 'Quantity for ' + item.title);
            quantity.addEventListener('change', () => { item.quantity = Math.max(1, Math.min(99, Number.parseInt(quantity.value, 10) || 1)); selectedView(); renderScene(); });
            const remove = node('button', '', 'Remove'); remove.type = 'button'; remove.setAttribute('aria-label', 'Remove ' + item.title);
            remove.addEventListener('click', () => {
              selected = selected.filter(entry => entry !== item);
              if (item.isLock) selected = selected.filter(entry => {
                if (entry.doorId !== item.doorId) return true;
                if (entry.isGlassAccessory) return entry.glassLockKey !== item.lockKey;
                if (entry.isMaglockBracket) return entry.bracketLockKey !== item.lockKey;
                return true;
              });
              selectedView(); renderScene();
              if ((scene === 'glass' && active?.key === 'glass-accessories') || active?.key === 'bracket') productsView();
            });
            controls.append(quantity, remove); row.append(description, controls); group.append(row);
          });
          list.append(group);
        });
        if (!doorItemsForSummary.length) {
          const empty = node('section', 'das-byo__selection-group');
          empty.append(node('h3', 'das-byo__selection-heading', door.name), node('p', 'das-byo__muted', 'No components selected yet.'));
          list.append(empty);
        }
      });
      const missingBrackets = doors.flatMap(door => missingGlassBrackets(door.id));
      renderChecklist();
      renderComponentChecklist();
      doors.forEach(door => {
        const state = root.querySelector('[data-door-state="' + door.id + '"]');
        if (!state) return;
        const doorCount = selectionsForDoor(door.id).reduce((sum, item) => sum + item.quantity, 0);
        state.textContent = doorCount ? doorCount + (doorCount === 1 ? ' component' : ' components') : 'Not configured';
      });
      const incompleteDoor = doors.some(door => {
        const items = selectionsForDoor(door.id);
        const hasEmergencyRelease = items.some(item => item.rangeHandle === 'break-glass-call-points');
        return !items.length || !door.doorAction || missingGlassBrackets(door.id).length > 0 || (!hasEmergencyRelease && !door.manualOverrideConfirmed);
      });
      const manualOverrideConfirmed = hasBreakglass || Boolean(emergencyConfirm?.checked);
      if (missingBrackets.length) list.append(node('p', 'das-byo__muted', 'Required: add a matching glass bracket for each selected glass-door lock before adding the system to your basket or Project.'));
      if (!selected.length) list.append(node('p', 'das-byo__muted', 'Products you choose will appear here.'));
      $('[data-count]').textContent = count + (count === 1 ? ' item' : ' items');
      $('[data-total]').textContent = priceText(total); $('[data-total-row]').hidden = !selected.length;
      $('[data-add-cart]').disabled = !selected.length || incompleteDoor || missingBrackets.length > 0 || !manualOverrideConfirmed;
      if ($('[data-add-project]')) $('[data-add-project]').disabled = !selected.length || incompleteDoor || missingBrackets.length > 0 || !manualOverrideConfirmed;
    };

    const productsView = async () => {
      const requestedPoint = active, requestedRange = range, list = picker.querySelector('[data-products]');
      list.replaceChildren(node('p', '', 'Loading products…'));
      try {
        const products = await loadRange(requestedRange);
        let glassAccessoryCatalog = [];
        const isGlassLockPicker = scene === 'glass' && requestedPoint.key === 'lock';
        const isGlassAccessoryPicker = scene === 'glass' && requestedPoint.key === 'glass-accessories';
        const isBracketPicker = requestedPoint.key === 'bracket' && scene !== 'gate';
        if (isGlassLockPicker || isGlassAccessoryPicker || isBracketPicker) {
          const [maglockAccessories, shearBoltProducts] = await Promise.all([
            loadRange('maglock-brackets-and-accessories'), loadRange('shearlocks-bolts')
          ]);
          glassAccessoryCatalog = [...maglockAccessories, ...shearBoltProducts];
        }
        if (active !== requestedPoint || range !== requestedRange) return;
        const requiredSuitability = scene === 'gate'
          ? 'exterior_weatherproof'
          : requestedPoint.environment === 'exterior'
            ? 'exterior_ip_rated'
            : 'internal';
        const isCoveredGatePowerSupply = scene === 'gate' && requestedPoint.key === 'psu';
        const isKeypadReaderRange = requestedPoint.key === 'reader' && requestedRange === 'key-pads';
        const glassAccessoryHandlesByLock = new Map(), glassAccessoryAllByLock = new Map();
        const sourceProducts = isGlassAccessoryPicker
          ? currentSelections().filter(lock => lock.isLock && (lock.glassAccessoryHandles || []).length).flatMap(lock =>
              (lock.glassAccessoryHandles || []).map(handle => {
                const accessory = glassAccessoryCatalog.find(product => product.handle === handle);
                return accessory ? { ...accessory, glassLockKey: lock.lockKey, glassLockTitle: lock.title } : null;
              }).filter(Boolean)
            )
          : isBracketPicker
            ? currentSelections().filter(item => item.isLock && item.rangeHandle === 'maglocks').flatMap(lock =>
                accessoriesForLock(lock, glassAccessoryCatalog).map(accessory => ({ ...accessory, bracketLockKey: lock.lockKey, bracketLockTitle: lock.title }))
              )
            : products;
        const suitableProducts = sourceProducts.filter(product => {
          if (isGlassLockPicker) {
            if ((product.product_type || '').toLowerCase().includes('accessor')) return false;
            const allHandles = glassAccessoriesForLock(product, glassAccessoryCatalog);
            glassAccessoryAllByLock.set(product.handle, allHandles);
            const handles = allHandles.filter(handle => { const accessory = glassAccessoryCatalog.find(entry => entry.handle === handle); const family = bracketFamily(accessory || {}); return family === 'shared' || family === doorAction; });
            if (handles.length) glassAccessoryHandlesByLock.set(product.handle, handles);
            return Boolean(doorAction) && handles.length > 0;
          }
          if (isGlassAccessoryPicker) return true;
          if (isBracketPicker) { const family = bracketFamily(product); const text = [product.title, product.handle, product.product_type].join(' ').toLowerCase(); return !/glass/.test(text) && (family === 'shared' || family === doorAction); }
          if (scene === 'gate' && requestedPoint.key === 'bracket') {
            const family = bracketFamily(product), suitability = product.builder_suitability;
            return (family === 'shared' || family === doorAction) && Array.isArray(suitability) && suitability.includes('exterior_weatherproof');
          }
          if (isKeypadReaderRange) {
            const productText = [product.title, product.handle, product.product_type].join(' ').toLowerCase();
            return !(/\bfobs?\b|\bproximity cards?\b|\brain cover\b|\bprivacy shield\b|\baccessories\b/.test(productText));
          }
          if (requestedPoint.key === 'release' && requestedRange === 'break-glass-call-points' && ((product.product_type || '').toLowerCase().includes('keyswitch') || excludedBreakglassHandles.has(product.handle))) return false;
          if (requestedRange === 'door-loops' && scene !== 'gate') return true;
          if (requestedPoint.key === 'strike' && requestedRange === 'electric-strikes') return true;
          if (requestedPoint.key === 'psu' && /\bdin(?:[\s-]*rail)?\b/i.test([product.title, product.handle, product.product_type].join(' '))) return false;
          const suitability = product.builder_suitability;
          if (!Array.isArray(suitability)) return false;
          return isCoveredGatePowerSupply
            ? suitability.includes('internal') || suitability.includes('exterior_weatherproof')
            : suitability.includes(requiredSuitability);
        });
        const configuredRecommendedId = root.dataset['recommend' + requestedRange.split('-').map(part => part[0].toUpperCase() + part.slice(1)).join('')];
        const recommendationSet = recommendations[scene] || {};
        let recommendedHandles = requestedPoint.key === 'bracket' ? (recommendationSet.bracket?.[doorAction] || []) :
          requestedPoint.key === 'glass-accessories' ? (recommendationSet['glass-accessories']?.[doorAction] || []) :
          (recommendationSet[requestedPoint.key] || []);
        if (!recommendedHandles.length && configuredRecommendedId) {
          const configured = suitableProducts.find(product => String(product.id) === configuredRecommendedId);
          if (configured) recommendedHandles = [configured.handle];
        }
        const sorted = [...suitableProducts].sort((a, b) => {
          const ai = recommendedHandles.indexOf(a.handle), bi = recommendedHandles.indexOf(b.handle);
          return (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi);
        });
        let enclosureSuggestion = null;
        if (isCoveredGatePowerSupply) {
          try {
            const enclosures = await loadRange('lockable-boxes');
            const ratedEnclosures = enclosures.filter(product =>
              Array.isArray(product.builder_suitability) &&
              product.builder_suitability.includes('exterior_ip_rated') &&
              product.builder_suitability.includes('exterior_weatherproof')
            );
            enclosureSuggestion = ratedEnclosures.find(product => /IPbox-5/i.test(product.title)) ||
              ratedEnclosures.find(product => /IPbox/i.test(product.title)) || null;
          } catch (_) {}
        }
        if (active !== requestedPoint || range !== requestedRange) return;
        const search = picker.querySelector('[data-search]');
        const isPsuPicker = requestedPoint.key === 'psu' && requestedRange === 'psus';
        const voltageValues = product => (Array.isArray(product.voltage) ? product.voltage : [product.voltage]).filter(value => value != null && value !== '').map(value => String(value).replace(/\s/g, '').toUpperCase());
        const currentValues = product => (Array.isArray(product.current) ? product.current : [product.current]).filter(value => value != null && value !== '').map(value => String(value).replace(/\s/g, '').toUpperCase());
        const voltageButtons = [...picker.querySelectorAll('[data-psu-voltage]')];
        const currentButtons = [...picker.querySelectorAll('[data-psu-current]')];
        const syncPsuFilters = () => {
          voltageButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.psuVoltage === psuVoltage)));
          currentButtons.forEach(button => {
            const valid = button.dataset.validVoltage || '';
            button.hidden = Boolean(psuVoltage && valid && !valid.split(',').includes(psuVoltage));
            button.setAttribute('aria-pressed', String(button.dataset.psuCurrent === psuCurrent));
          });
        };
        const render = () => {
          list.replaceChildren(); let matches = 0;
          const term = search.value.trim().toLowerCase();
          for (const product of sorted) {
            if (isPsuPicker && psuVoltage && !voltageValues(product).includes(psuVoltage)) continue;
            if (isPsuPicker && psuCurrent && !currentValues(product).includes(psuCurrent)) continue;
            const searchText = [product.title, product.handle, ...(product.variants || []).map(variant => variant.sku || '')].join(' ').toLowerCase();
            if (term && !searchText.includes(term)) continue;
            matches++;
            const card = node('article', 'das-byo__product'), photo = node('img'), details = node('div');
            photo.alt = ''; photo.loading = 'lazy'; photo.src = product.featured_image || product.images?.[0] || '';
            if (recommendedHandles.includes(product.handle)) details.append(node('small', 'das-byo__recommend', 'WE RECOMMEND'));
            if (isGlassAccessoryPicker) details.append(node('small', 'das-byo__compatibility-label', 'For ' + product.glassLockTitle));
            if (isBracketPicker) details.append(node('small', 'das-byo__compatibility-label', 'Compatible with ' + product.bracketLockTitle));
            const titleLink = node('a', 'das-byo__product-link', product.title); titleLink.href = '/products/' + encodeURIComponent(product.handle); titleLink.dataset.productQuickView = ''; titleLink.dataset.productHandle = product.handle; titleLink.dataset.productDescription = product.description || product.body_html || '';
            const titleHeading = node('h3'); titleHeading.append(titleLink); details.append(titleHeading);
            const variants = product.variants || [], select = node('select');
            select.setAttribute('aria-label', 'Variant for ' + product.title);
            variants.forEach((variant, index) => { const option = new Option(variant.title === 'Default Title' ? 'Standard' : variant.title, String(index)); option.disabled = !variant.available; select.add(option); });
            const firstAvailable = variants.findIndex(variant => variant.available); select.value = String(firstAvailable < 0 ? 0 : firstAvailable);
            const price = node('strong'), add = node('button', '', 'Add component'), remove = node('button', 'das-byo__remove-component', 'Remove'), selectedState = node('small', 'das-byo__selected-state', 'Selected');
            add.type = 'button'; remove.type = 'button'; remove.hidden = true; selectedState.hidden = true;
            const getSelectedItem = variant => variant && currentSelections().find(entry => entry.variantId === variant.id && entry.position === active.label && (!isGlassAccessoryPicker || entry.glassLockKey === product.glassLockKey) && (!isBracketPicker || entry.bracketLockKey === product.bracketLockKey));
            const update = () => {
              const variant = variants[Number(select.value)], selectedItem = getSelectedItem(variant);
              price.textContent = variant ? priceText(variant.price) : ''; add.disabled = !variant?.available;
              card.classList.toggle('is-selected', Boolean(selectedItem)); selectedState.hidden = !selectedItem;
              add.textContent = selectedItem ? 'Add another' : 'Add component'; remove.hidden = !selectedItem;
              remove.setAttribute('aria-label', 'Remove ' + product.title + (variant?.title && variant.title !== 'Default Title' ? ' - ' + variant.title : ''));
            };
            select.addEventListener('change', update); update();
            add.addEventListener('click', () => {
              const variant = variants[Number(select.value)];
              const item = {
                productId: product.id, variantId: variant.id, title: product.title, doorId: activeDoorId,
                variantTitle: variant.title === 'Default Title' ? '' : variant.title,
                productUrl: '/products/' + product.handle, productHandle: product.handle,
                price: variant.price, position: active.label, quantity: 1, rangeHandle: requestedRange,
                isLock: requestedPoint.key === 'lock' || requestedPoint.key === 'strike', isMaglockBracket: requestedPoint.key === 'bracket',
                lockKey: requestedPoint.key === 'lock' || requestedPoint.key === 'strike' ? product.handle + ':' + variant.id + ':' + active.label : null,
                isGlassAccessory: isGlassAccessoryPicker,
                glassAccessoryHandles: isGlassLockPicker ? (glassAccessoryHandlesByLock.get(product.handle) || []) : [],
                glassAccessoryHandlesAll: isGlassLockPicker ? (glassAccessoryAllByLock.get(product.handle) || []) : [],
                glassAccessoryFamilies: isGlassLockPicker ? Object.fromEntries((glassAccessoryAllByLock.get(product.handle) || []).map(handle => [handle, bracketFamily(glassAccessoryCatalog.find(entry => entry.handle === handle) || {})])) : null,
                bracketLockKey: isBracketPicker ? product.bracketLockKey : null,
                bracketLockTitle: isBracketPicker ? product.bracketLockTitle : null,
                bracketFamily: isBracketPicker ? bracketFamily(product) : null,
                glassLockKey: isGlassAccessoryPicker ? product.glassLockKey : null,
                glassLockTitle: isGlassAccessoryPicker ? product.glassLockTitle : null,
                doorAction: isGlassAccessoryPicker ? bracketFamily(product) : (isBracketPicker ? doorAction : '')
              };
              const existing = selected.find(entry => entry.doorId === activeDoorId && entry.variantId === variant.id && entry.position === active.label && (!isGlassAccessoryPicker || entry.glassLockKey === product.glassLockKey) && (!isBracketPicker || entry.bracketLockKey === product.bracketLockKey));
              if (existing) {
                existing.quantity++;
                existing.glassLockKey = item.glassLockKey;
              } else selected.push(item);
              selectedView(); renderScene(); say(product.title + ' added to your system.'); productsView();
            });
            remove.addEventListener('click', () => {
              const variant = variants[Number(select.value)], selectedItem = getSelectedItem(variant);
              if (!selectedItem) return;
              selected = selected.filter(entry => entry !== selectedItem);
              if (selectedItem.isLock) selected = selected.filter(entry => {
                if (entry.doorId !== selectedItem.doorId) return true;
                if (entry.isGlassAccessory) return entry.glassLockKey !== selectedItem.lockKey;
                if (entry.isMaglockBracket) return entry.bracketLockKey !== selectedItem.lockKey;
                return true;
              });
              selectedView(); renderScene(); say(product.title + ' removed from your system.'); productsView();
            });
            if (variants.length > 1) details.append(select);
            details.append(selectedState, price, add, remove); card.append(photo, details); list.append(card);
          }
          if (!matches) list.append(node('p', '', isPsuPicker && (psuVoltage || psuCurrent) && sorted.length ? 'No power supplies match those filters.' : isGlassLockPicker
            ? (doorAction ? 'No maglocks or bolts have a compatible glass bracket for this door action.' : 'Select push or pull above to see compatible glass-door locks.')
            : isGlassAccessoryPicker
              ? 'No glass-door accessories match the lock or locks selected for this door action.'
              : isBracketPicker && !doorAction ? 'Choose push or pull to see compatible L brackets or Z&L brackets.'
                : isBracketPicker ? 'No compatible accessories were found for the selected maglock and door action.'
              : suitableProducts.length ? 'No products match your search.' : (requiredSuitability === 'exterior_weatherproof' ? 'No products are marked as weatherproof and suitable for gates.' : requiredSuitability === 'exterior_ip_rated' ? 'No products are marked as IP-rated and suitable for exterior use.' : 'No products are marked as suitable for internal use.')));
          if (enclosureSuggestion) {
            const variant = (enclosureSuggestion.variants || []).find(entry => entry.available);
            if (variant) {
              const card = node('article', 'das-byo__product'), photo = node('img'), details = node('div');
              photo.alt = ''; photo.loading = 'lazy'; photo.src = enclosureSuggestion.featured_image || enclosureSuggestion.images?.[0] || '';
              details.append(node('small', 'das-byo__recommend', 'LARGE IP-RATED ENCLOSURE SUGGESTED'));
              const enclosureTitleLink = node('a', 'das-byo__product-link', enclosureSuggestion.title); enclosureTitleLink.href = '/products/' + encodeURIComponent(enclosureSuggestion.handle); enclosureTitleLink.target = '_blank'; enclosureTitleLink.rel = 'noopener';
              const enclosureTitle = node('h3'); enclosureTitle.append(enclosureTitleLink); details.append(enclosureTitle);
              details.append(node('p', '', 'Suggested to house the power supply in the covered gate location.'));
              const price = node('strong'), addEnclosure = node('button', '', 'Add suggested enclosure');
              price.textContent = priceText(variant.price); addEnclosure.type = 'button';
              addEnclosure.addEventListener('click', () => {
                const item = { productId: enclosureSuggestion.id, variantId: variant.id, title: enclosureSuggestion.title, doorId: activeDoorId, variantTitle: variant.title === 'Default Title' ? '' : variant.title, productUrl: '/products/' + enclosureSuggestion.handle, price: variant.price, position: 'Gate power supply enclosure', quantity: 1, rangeHandle: 'lockable-boxes', isLock: false, isMaglockBracket: false };
                const existing = selected.find(entry => entry.doorId === activeDoorId && entry.variantId === item.variantId && entry.position === item.position);
                if (existing) existing.quantity++;
                else selected.push(item);
                selectedView(); renderScene(); say(enclosureSuggestion.title + ' added to your system.');
              });
              details.append(price, addEnclosure); card.append(photo, details); list.append(card);
            }
          }
        };
        if (isPsuPicker) {
          syncPsuFilters();
          voltageButtons.forEach(button => button.addEventListener('click', () => {
            psuVoltage = button.dataset.psuVoltage;
            const currentOption = currentButtons.find(option => option.dataset.psuCurrent === psuCurrent);
            if (psuCurrent && currentOption?.dataset.validVoltage && !currentOption.dataset.validVoltage.split(',').includes(psuVoltage)) psuCurrent = '';
            syncPsuFilters(); render();
          }));
          currentButtons.forEach(button => button.addEventListener('click', () => {
            psuCurrent = button.dataset.psuCurrent;
            syncPsuFilters(); render();
          }));
        }
        search.addEventListener('input', render); render();
      } catch (error) { list.replaceChildren(node('p', '', error.message || 'Could not load products.')); }
    };

    let anySearchTimer = null, anySearchRequest = 0;
    const searchAnyProducts = async (term, page = 1, append = false) => {
      const query = term.trim();
      const requestId = ++anySearchRequest;
      if (query.length < 2) {
        anyProducts.replaceChildren();
        anyPagination.replaceChildren();
        anyStatus.textContent = 'Enter at least 2 characters to search all products.';
        return;
      }
      anyStatus.textContent = 'Searching products…';
      if (!append) { anyProducts.replaceChildren(); anyPagination.replaceChildren(); }
      try {
        const url = new URL('/search', location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', query);
        url.searchParams.set('view', 'das-builder-feed');
        url.searchParams.set('page', String(page));
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search failed (request returned ' + response.status + ').');
        const data = await response.json();
        if (requestId !== anySearchRequest) return;
        const products = (data.products || []).filter(product => (product.variants || []).some(variant => variant.available));
        if (!append) anyProducts.replaceChildren();
        let matches = 0;
        products.forEach(product => {
          const variants = product.variants || [], availableVariants = variants.map((variant, index) => ({ variant, index })).filter(entry => entry.variant.available);
          if (!availableVariants.length) return;
          matches++;
          const card = node('article', 'das-byo__product'), photo = node('img'), details = node('div');
          photo.alt = ''; photo.loading = 'lazy'; photo.src = product.featured_image || product.images?.[0] || '';
          const titleLink = node('a', 'das-byo__product-link', product.title);
          titleLink.href = '/products/' + encodeURIComponent(product.handle); titleLink.dataset.productQuickView = ''; titleLink.dataset.productHandle = product.handle; titleLink.dataset.productDescription = product.description || product.body_html || '';
          const titleHeading = node('h3'); titleHeading.append(titleLink); details.append(titleHeading);
          const select = node('select'); select.setAttribute('aria-label', 'Variant for ' + product.title);
          availableVariants.forEach(({variant,index}) => select.add(new Option(variant.title === 'Default Title' ? 'Standard' : variant.title, String(index))));
          const price = node('strong'), add = node('button', '', 'Add component'), remove = node('button', 'das-byo__remove-component', 'Remove'), selectedState = node('small', 'das-byo__selected-state', 'Selected');
          add.type = 'button'; remove.type = 'button'; remove.hidden = true; selectedState.hidden = true;
          const getSelectedItem = variant => variant && currentSelections().find(item => item.variantId === variant.id && item.rangeHandle === 'any-product-search');
          const update = () => {
            const variant = variants[Number(select.value)], selectedItem = getSelectedItem(variant);
            price.textContent = variant ? priceText(variant.price) : '';
            card.classList.toggle('is-selected', Boolean(selectedItem)); selectedState.hidden = !selectedItem;
            add.textContent = selectedItem ? 'Add another' : 'Add component'; remove.hidden = !selectedItem;
            remove.setAttribute('aria-label', 'Remove ' + product.title);
          };
          select.addEventListener('change', update); update();
          add.addEventListener('click', () => {
            if (!doorAction) {
              const warning = root.querySelector('[data-door-action-warning]');
              if (warning) { warning.hidden = false; warning.textContent = 'Please select Push or Pull before choosing a component.'; }
              doorActionSelect?.focus(); return;
            }
            const variant = variants[Number(select.value)];
            if (!variant?.available) return;
            const existing = getSelectedItem(variant);
            if (existing) existing.quantity++;
            else selected.push({
              productId: product.id, variantId: variant.id, title: product.title, doorId: activeDoorId,
              variantTitle: variant.title === 'Default Title' ? '' : variant.title,
              productUrl: '/products/' + product.handle, productHandle: product.handle,
              price: variant.price, position: 'Additional components · manual search', quantity: 1,
              rangeHandle: 'any-product-search', isLock: false, isMaglockBracket: false
            });
            selectedView(); renderScene(); renderDoorList(); update();
            say(product.title + ' added to your system.');
          });
          remove.addEventListener('click', () => {
            const variant = variants[Number(select.value)], selectedItem = getSelectedItem(variant);
            if (!selectedItem) return;
            selected = selected.filter(item => item !== selectedItem);
            selectedView(); renderScene(); renderDoorList(); update();
            say(product.title + ' removed from your system.');
          });
          if (availableVariants.length > 1) details.append(select);
          details.append(selectedState, price, add, remove); card.append(photo, details); anyProducts.append(card);
        });
        const pageCount = products.length;
        anyStatus.textContent = matches ? (matches + (matches === 1 ? ' product found.' : ' products found.') + ' These results are not compatibility-filtered; check suitability and ratings before adding.') : 'No products found for “' + query + '”.';
        anyPagination.replaceChildren();
        if (page > 1) {
          const previous = node('button', '', 'Previous'); previous.type = 'button';
          previous.addEventListener('click', () => searchAnyProducts(query, page - 1, false));
          anyPagination.append(previous);
        }
        if (data.next_page) {
          const next = node('button', '', 'Next'); next.type = 'button';
          next.addEventListener('click', async () => {
            const oldRequest = anySearchRequest;
            await searchAnyProducts(query, data.next_page, true);
            if (oldRequest !== anySearchRequest) return;
          });
          anyPagination.append(next);
        }
      } catch (error) {
        if (requestId === anySearchRequest) anyStatus.textContent = error.message || 'Could not search products.';
      }
    };
    anySearch.addEventListener('input', () => {
      clearTimeout(anySearchTimer);
      anySearchTimer = setTimeout(() => searchAnyProducts(anySearch.value), 250);
    });

    const renderScene = () => {
      const spec = scenes[scene]; image.src = images[scene]; image.alt = spec.label + ' with selectable component positions';
      hotspots.replaceChildren(); positions.replaceChildren();
      const doorScene = scene === 'timber' || scene === 'aluminium';
      const doorSelections = currentSelections();
      const hasDoorStrike = doorScene && doorSelections.some(item => item.isLock && item.rangeHandle === 'electric-strikes');
      const hasDoorMaglockOrBolt = doorScene && doorSelections.some(item => item.isLock && ['maglocks', 'shearlocks-bolts'].includes(item.rangeHandle));
      spec.points.filter(pointSpec =>
        (!pointSpec.requiresLock || currentSelections().some(item => item.isLock && item.rangeHandle === pointSpec.requiresLock)) &&
        (!pointSpec.requiresGlassLock || currentSelections().some(item => item.isLock && (item.glassAccessoryHandles || []).length)) &&
        !(hasDoorStrike && (pointSpec.key === 'lock' || pointSpec.key === 'bracket')) &&
        !(hasDoorMaglockOrBolt && pointSpec.key === 'strike')
      ).forEach(pointSpec => {
        const count = currentSelections().filter(item => item.position === pointSpec.label).reduce((sum, item) => sum + item.quantity, 0);
        const required = pointSpec.requiresGlassLock && missingGlassBrackets(activeDoorId).length > 0;
        const component = componentNames[pointSpec.key] || { marker: pointSpec.label, list: pointSpec.label };
        const hotspot = node('button', 'das-byo__hotspot', component.marker); hotspot.type = 'button';
        hotspot.style.left = pointSpec.x + '%'; hotspot.style.top = pointSpec.y + '%';
        hotspot.setAttribute('aria-pressed', String(active?.key === pointSpec.key));
        hotspot.setAttribute('aria-label', 'Choose ' + component.list + (required ? ' (required)' : '') + (count ? ', ' + count + ' selected' : ''));
        hotspot.addEventListener('click', () => open(pointSpec));
        if (count) hotspot.append(node('span', 'das-byo__badge', String(count)));
        hotspots.append(hotspot);
        const position = node('button', '', component.list + (required ? ' (required)' : '') + (count ? ' (' + count + ')' : '')); position.type = 'button'; position.setAttribute('aria-pressed', String(active?.key === pointSpec.key));
        position.addEventListener('click', () => open(pointSpec)); positions.append(position);
      });
      const availableExtras = scene === 'gate' ? extras.filter(extra => extra.key !== 'door-loops') : extras;
      extrasOptions.replaceChildren(...availableExtras.map(extra => {
        const button = node('button', '', names[extra.ranges[0]] || extra.label);
        button.type = 'button';
        button.setAttribute('aria-pressed', String(active?.key === extra.key));
        button.addEventListener('click', () => open(extra));
        return button;
      }));
    };

    const syncSceneButtons = () => root.querySelectorAll('[data-scene]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scene === scene)));
    const switchDoor = doorId => {
      if (!doors.some(door => door.id === doorId)) return;
      activeDoorId = doorId;
      scene = currentDoor().scene || 'timber';
      doorAction = currentDoor().doorAction || '';
      active = null; range = null;
      const warning = root.querySelector('[data-door-action-warning]');
      if (warning) { warning.hidden = true; warning.textContent = ''; }
      picker.replaceChildren();
      syncSceneButtons(); syncDoorActionControl();
      if (emergencyConfirm) emergencyConfirm.checked = Boolean(currentDoor().manualOverrideConfirmed);
      renderDoorList(); renderScene(); selectedView();
    };
    const renderDoorList = () => {
      const list = root.querySelector('[data-door-list]');
      if (!list) return;
      const addDoorButton = root.querySelector('[data-add-door]');
      list.replaceChildren();
      doors.forEach((door, index) => {
        const row = node('div', 'das-byo__door-row'); row.dataset.doorRow = door.id;
        const name = node('input', 'das-byo__door-name'); name.type = 'text'; name.value = door.name;
        name.maxLength = 60; name.dataset.doorNameInput = door.id; name.setAttribute('aria-label', 'Name for door ' + (index + 1));
        name.classList.toggle('is-active', door.id === activeDoorId);
        name.addEventListener('focus', () => {
          if (door.id !== activeDoorId) {
            switchDoor(door.id);
            requestAnimationFrame(() => root.querySelector('[data-door-name-input="' + door.id + '"]')?.focus());
          }
        });
        name.addEventListener('change', () => {
          door.name = name.value.trim() || 'Door ' + (index + 1);
          name.value = door.name;
          renderDoorList(); syncDoorActionControl(); selectedView();
        });
        const selectDoor = node('button', 'das-byo__door-select', door.id === activeDoorId ? 'Building this door' : 'Select door');
        selectDoor.type = 'button';
        selectDoor.setAttribute('aria-pressed', String(door.id === activeDoorId));
        selectDoor.disabled = door.id === activeDoorId;
        selectDoor.addEventListener('click', () => switchDoor(door.id));
        const status = node('small', 'das-byo__door-state'); status.dataset.doorState = door.id;
        const itemCount = selectionsForDoor(door.id).reduce((sum, item) => sum + item.quantity, 0);
        status.textContent = itemCount ? itemCount + (itemCount === 1 ? ' component' : ' components') : 'Not configured';
        const nameWrap = node('div', 'das-byo__door-name-wrap');
        nameWrap.append(name, selectDoor);
        if (index === 0 && addDoorButton) nameWrap.append(addDoorButton);
        row.append(nameWrap, status);
        if (doors.length > 1) {
          const remove = node('button', 'das-byo__door-remove', 'Remove'); remove.type = 'button';
          remove.setAttribute('aria-label', 'Remove ' + door.name);
          remove.addEventListener('click', () => {
            if (!window.confirm('Remove ' + door.name + ' and all of its selected components?')) return;
            doors = doors.filter(entry => entry.id !== door.id);
            selected = selected.filter(item => item.doorId !== door.id);
            if (activeDoorId === door.id) {
              const next = doors[Math.max(0, index - 1)];
              activeDoorId = next.id; scene = next.scene; doorAction = next.doorAction;
              active = null; range = null; picker.replaceChildren(); syncSceneButtons(); syncDoorActionControl();
            }
            renderDoorList(); renderScene(); selectedView();
          });
          row.append(remove);
        }
        list.append(row);
      });
    };
    root.querySelector('[data-add-door]')?.addEventListener('click', () => {
      const nextNumber = Math.max(0, ...doors.map(door => Number((door.name.match(/\d+/) || [])[0]) || 0)) + 1;
      const door = { id: crypto.randomUUID(), name: 'Door ' + nextNumber, scene: 'timber', doorAction: '', manualOverrideConfirmed: false };
      doors.push(door); switchDoor(door.id);
      say(door.name + ' created. Choose its entrance type and build its system.');
    });
    const open = pointSpec => {
      const warning = root.querySelector('[data-door-action-warning]');
      if (!doorAction) {
        if (warning) { warning.hidden = false; warning.textContent = 'Choose Push or Pull for ' + currentDoor().name + ' first. Each door has its own opening direction.'; }
        doorActionControl?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        doorActionSelect?.focus({ preventScroll: true });
        return;
      }
      if (warning) { warning.hidden = true; warning.textContent = ''; }
      active = pointSpec;
      range = pointSpec.ranges[0];
      picker.replaceChildren(node('p', 'das-byo__eyebrow', 'CHOOSE A COMPONENT'), node('h2', '', pointSpec.label));
      const environmentNote = scene === 'gate' && pointSpec.key === 'psu'
        ? 'Covered gate location: power supplies can be used here. We recommend adding the large IP-rated enclosure below.'
        : scene === 'gate' && pointSpec.key === 'reader'
          ? 'All gate keypads and readers are shown. Check product IP ratings for external installation.'
          : scene === 'gate'
            ? 'Gate: weatherproof exterior products only.'
          : scene === 'glass' && pointSpec.key === 'lock'
            ? 'Glass doors: only maglocks and bolts with matching glass-door accessories are offered. Strikes are not available.'
            : scene === 'glass' && pointSpec.key === 'glass-accessories'
              ? 'Select at least one compatible glass bracket for each selected lock. Different locks may need different brackets.'
              : pointSpec.key === 'reader'
            ? 'All door keypads and readers are shown. Check product ratings for exterior installation; only keypad and reader products are offered.'
            : pointSpec.environment === 'exterior'
              ? 'Exterior face: IP-rated products intended for external use.'
              : 'Interior face: products suitable for internal use.';
      if (pointSpec.key !== 'strike') picker.append(node('p', 'das-byo__environment', environmentNote));
      const tabs = node('div', 'das-byo__range-tabs'), search = node('input', 'das-byo__search'), products = node('div', 'das-byo__products');
      let psuFilters = null;
      if (pointSpec.key === 'psu') {
        psuFilters = node('div', 'das-byo__psu-filters');
        const makeGroup = (label, dataName, options) => {
          const group = node('div', 'das-byo__psu-filter-group'), heading = node('span', 'das-byo__psu-filter-label', label), choices = node('div', 'das-byo__psu-filter-choices');
          choices.setAttribute('role', 'group'); choices.setAttribute('aria-label', label);
          options.forEach(optionData => {
            const button = node('button', '', optionData.label); button.type = 'button'; button.dataset[dataName] = optionData.value;
            if (optionData.validVoltage) button.dataset.validVoltage = optionData.validVoltage;
            button.setAttribute('aria-pressed', String(optionData.value === ''));
            choices.append(button);
          });
          group.append(heading, choices); return group;
        };
        const voltages = makeGroup('Voltage', 'psuVoltage', [{ label: 'All', value: '' }, { label: '12V', value: '12V' }, { label: '24V', value: '24V' }]);
        const currents = makeGroup('Current', 'psuCurrent', [
          { label: 'All', value: '' }, { label: '0.5A', value: '0.5A', validVoltage: '24V' },
          { label: '1A', value: '1A', validVoltage: '12V,24V' }, { label: '2A', value: '2A', validVoltage: '12V,24V' },
          { label: '2.5A', value: '2.5A', validVoltage: '24V' }, { label: '3A', value: '3A', validVoltage: '12V,24V' },
          { label: '4A', value: '4A', validVoltage: '24V' }, { label: '5A', value: '5A', validVoltage: '12V,24V' },
          { label: '10A', value: '10A', validVoltage: '12V' }
        ]);
        psuFilters.append(voltages, currents);
        const filterButtons = [...psuFilters.querySelectorAll('[data-psu-voltage], [data-psu-current]')];
        filterButtons.forEach(button => button.setAttribute('aria-pressed', 'false'));
        psuFilters.querySelector('[data-psu-voltage=""]').setAttribute('aria-pressed', 'true');
        psuFilters.querySelector('[data-psu-current=""]').setAttribute('aria-pressed', 'true');
      }

      tabs.setAttribute('role', 'group'); tabs.setAttribute('aria-label', 'Product range');
      search.type = 'search'; search.placeholder = 'Search products or SKU'; search.setAttribute('aria-label', 'Search products'); search.dataset.search = '';
      products.dataset.products = '';
      const availableRanges = pointSpec.ranges;
      availableRanges.forEach(handle => {
        const tab = node('button', '', names[handle]); tab.type = 'button'; tab.setAttribute('aria-pressed', String(handle === range));
        tab.addEventListener('click', () => { range = handle; search.value = ''; [...tabs.children].forEach(child => child.setAttribute('aria-pressed', String(child === tab))); productsView(); });
        tabs.append(tab);
      });
      picker.append(tabs);
      if (psuFilters) picker.append(psuFilters);
      picker.append(search, products);
      renderScene(); productsView();
      if (innerWidth < 900) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const doorActionControl = root.querySelector('[data-door-action-control]');
    emergencyConfirm?.addEventListener('change', () => { currentDoor().manualOverrideConfirmed = Boolean(emergencyConfirm.checked); selectedView(); });
    const doorActionSelect = root.querySelector('[data-door-action]');
    const doorActionLabel = root.querySelector('[data-door-action-label]');
    const syncDoorActionControl = () => {
      if (!doorActionControl || !doorActionSelect) return;
      doorActionControl.hidden = false;
      doorActionSelect.value = doorAction;
      if (doorActionLabel) doorActionLabel.textContent = 'Required for ' + currentDoor().name + ': choose Push or Pull (opening direction)';
    };
    if (doorActionSelect) doorActionSelect.addEventListener('change', () => {
      doorAction = doorActionSelect.value; currentDoor().doorAction = doorAction;
      const warning = root.querySelector('[data-door-action-warning]'); if (warning) { warning.hidden = true; warning.textContent = ''; }
      if (scene === 'glass') currentSelections().filter(item => item.isLock && item.glassAccessoryHandlesAll).forEach(lock => {
        lock.glassAccessoryHandles = lock.glassAccessoryHandlesAll.filter(handle => {
          const family = lock.glassAccessoryFamilies?.[handle] || 'shared';
          return family === 'shared' || family === doorAction;
        });
      });
      selected = selected.filter(item => {
        if (item.doorId !== activeDoorId) return true;
        if (item.isGlassAccessory && item.doorAction && item.doorAction !== 'shared' && item.doorAction !== doorAction) return false;
        if (item.isMaglockBracket && item.bracketFamily && item.bracketFamily !== 'shared' && item.bracketFamily !== doorAction) return false;
        return true;
      });
      selectedView(); renderScene();
      if (active && (active.key === 'bracket' || active.key === 'glass-accessories' || (scene === 'glass' && active.key === 'lock'))) productsView();
    });
    root.querySelectorAll('[data-scene]').forEach(button => button.addEventListener('click', () => {
      const doorItems = currentSelections();
      if (doorItems.length && !window.confirm('Changing this entrance will clear the components assigned to ' + currentDoor().name + '. Continue?')) return;
      selected = selected.filter(item => item.doorId !== activeDoorId);
      scene = button.dataset.scene; currentDoor().scene = scene;
      doorAction = ''; currentDoor().doorAction = ''; currentDoor().manualOverrideConfirmed = false;
      if (emergencyConfirm) emergencyConfirm.checked = false;
      const warning = root.querySelector('[data-door-action-warning]'); if (warning) { warning.hidden = true; warning.textContent = ''; }
      active = null; range = null; selectedView(); syncDoorActionControl(); syncSceneButtons();
      picker.replaceChildren(); renderDoorList(); renderScene();
    }));

    $('[data-add-cart]').addEventListener('click', async () => {
      const button = $('[data-add-cart]'); button.disabled = true; say('Adding components…');
      try {
        const items = doors.flatMap(door => selectionsForDoor(door.id)).map(item => ({ id: item.variantId, quantity: item.quantity, properties: { '_DAS Builder': 'access-control', '_Builder Door': doors.find(door => door.id === item.doorId)?.name || 'Door 1', '_Builder Position': item.position } }));
        const response = await fetch(root.dataset.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || 'Could not add your system to the basket.'); }
        showCompletion('Your system has been added to your basket.', true);
      } catch (error) { say(error.message || 'Could not add your system to the basket.'); button.disabled = false; }
    });

    const productDialog = $('[data-product-dialog]');
    const quickViewTitle = $('[data-product-dialog-title]'), quickViewImage = $('[data-product-dialog-image]'), quickViewDescription = $('[data-product-dialog-description]'), quickViewPrice = $('[data-product-dialog-price]'), quickViewVendor = $('[data-product-dialog-vendor]'), quickViewLink = $('[data-product-dialog-link]');
    const completionDialog = $('[data-builder-complete]');
    const resetSystem = () => {
      selected = []; doorAction = ''; if (emergencyConfirm) emergencyConfirm.checked = false;
      const warning = root.querySelector('[data-door-action-warning]'); if (warning) { warning.hidden = true; warning.textContent = ''; }
      if (doorActionSelect) doorActionSelect.value = '';
      active = null; range = null; picker.replaceChildren();
      if (anySearch) anySearch.value = '';
      if (anyProducts) anyProducts.replaceChildren();
      if (anyStatus) anyStatus.textContent = 'Search the site catalogue by product name or SKU.';
      if (anyPagination) anyPagination.replaceChildren();
      doors = [{ id: 'door-1', name: 'Door 1', scene: 'timber', doorAction: '', manualOverrideConfirmed: false }];
      activeDoorId = 'door-1'; scene = 'timber'; doorAction = ''; active = null; range = null;
      if (doorActionSelect) doorActionSelect.value = '';
      selectedView(); syncSceneButtons(); syncDoorActionControl(); renderDoorList(); renderScene(); say('Your system has been cleared. Select Push or Pull to start again.');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const showCompletion = (message, basket = false, projects = false) => {
      if (!completionDialog) { say(message); return; }
      $('[data-complete-message]').textContent = message;
      $('[data-complete-basket]').hidden = !basket;
      $('[data-complete-projects]').hidden = !projects;
      completionDialog.showModal();
    };
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-product-quick-view]');
      if (!link || !root.contains(link)) return;
      event.preventDefault();
      if (!productDialog) { window.open(link.href, '_blank', 'noopener'); return; }
      const plainText = html => {
        const container = document.createElement('div');
        container.innerHTML = html || '';
        return (container.textContent || '').replace(/\s+/g, ' ').trim();
      };
      const productDescriptionFallback = plainText(link.dataset.productDescription || '');
      quickViewTitle.textContent = link.textContent;
      quickViewDescription.textContent = productDescriptionFallback || 'Loading product information…';
      quickViewVendor.textContent = '';
      quickViewPrice.textContent = '';
      quickViewImage.removeAttribute('src');
      quickViewLink.href = link.href;
      productDialog.showModal();
      try {
        const response = await fetch(link.href + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product details could not be loaded.');
        const product = await response.json();
        quickViewTitle.textContent = product.title || link.textContent;
        quickViewVendor.textContent = [product.vendor, product.type].filter(Boolean).join(' · ');
        const firstVariant = (product.variants || []).find(variant => variant.available) || product.variants?.[0];
        quickViewPrice.textContent = firstVariant ? priceText(Math.round(Number(firstVariant.price))) : '';
        quickViewImage.src = product.featured_image || product.images?.[0] || '';
        quickViewImage.alt = product.title || '';
        let description = plainText(product.description || product.body_html || product.descriptionHtml || '') || productDescriptionFallback;
        if (!description) {
          try {
            const pageResponse = await fetch(link.href, { credentials: 'same-origin' });
            if (pageResponse.ok) {
              const page = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
              const pageDescription = page.querySelector('[data-product-description], .product__description, .product-description, .product__content .rte');
              description = plainText(pageDescription?.innerHTML || page.querySelector('meta[name="description"]')?.content || page.querySelector('meta[property="og:description"]')?.content || '');
              if (!description) {
                const structuredDescriptions = [...page.querySelectorAll('script[type="application/ld+json"]')].flatMap(script => {
                  try {
                    const data = JSON.parse(script.textContent || 'null');
                    const entries = Array.isArray(data) ? data : data?.['@graph'] || [data];
                    return entries.filter(entry => entry && (entry['@type'] === 'Product' || (Array.isArray(entry['@type']) && entry['@type'].includes('Product')))).map(entry => entry.description || '');
                  } catch (_) { return []; }
                });
                description = plainText(structuredDescriptions.find(Boolean) || '');
              }
            }
          } catch (_) {}
        }
        quickViewDescription.textContent = description || 'Product details are available on the full product page.';
      } catch (_) {
        quickViewDescription.textContent = productDescriptionFallback || 'Product details are available on the full product page.';
      }
    });
    completionDialog?.querySelector('[data-complete-restart]')?.addEventListener('click', () => {
      completionDialog.close(); resetSystem();
    });
    completionDialog?.querySelector('[data-complete-continue]')?.addEventListener('click', () => completionDialog.close());
    completionDialog?.querySelector('[data-complete-basket]')?.addEventListener('click', () => { location.assign(root.dataset.cart); });
    completionDialog?.querySelector('[data-complete-projects]')?.addEventListener('click', () => { location.assign(root.dataset.projectsUrl); });
    const dialog = $('[data-project-dialog]');
    if (dialog) {
      const choice = $('[data-project-choice]'), name = $('[data-project-name]'), nameLabel = $('[data-new-label]');
      const builderDoorFields = $('[data-project-builder-doors]');
      let projects = [];
      const renderProjectDoorFields = () => {
        builderDoorFields.replaceChildren();
        const isNewProject = choice.value === 'new';
        const project = projects.find(entry => String(entry.id) === choice.value);
        if (!isNewProject) doors.forEach(door => {
          const row = node('div', 'das-byo__project-door-row');
          const targetWrap = node('div'), targetLabel = node('label', '', 'Add ' + door.name + ' to');
          const target = node('select'); target.dataset.projectDoorTarget = door.id;
          target.add(new Option('Create a new door: ' + door.name, 'new'));
          (project?.doors || []).forEach(projectDoor => target.add(new Option('Existing: ' + projectDoor.name, 'existing:' + projectDoor.id)));
          targetLabel.append(target); targetWrap.append(targetLabel); row.append(targetWrap);
          builderDoorFields.append(row);
        });
        name.hidden = !isNewProject; nameLabel.hidden = !isNewProject;
      };
      choice.addEventListener('change', renderProjectDoorFields);
      $('[data-add-project]').addEventListener('click', async () => {
        choice.replaceChildren(new Option('Create a new Project', 'new')); projects = [];
        renderProjectDoorFields();
        $('[data-project-status]').textContent = 'Loading your Projects…'; dialog.showModal();
        try {
          const response = await fetch(root.dataset.projectApi, { credentials: 'same-origin' }); const data = await response.json();
          if (!response.ok) throw new Error(data?.error?.message || 'Could not load Projects.');
          projects = (data.jobs || []).filter(project => project.status === 'live');
          projects.forEach(project => choice.add(new Option(project.name, project.id)));
          renderProjectDoorFields();
          $('[data-project-status]').textContent = '';
        } catch (error) {
          renderProjectDoorFields();
          $('[data-project-status]').textContent = error.message + ' You can still create a new Project.';
        }
      });
      $('[data-save-project]').addEventListener('click', async () => {
        const button = $('[data-save-project]'), isNew = choice.value === 'new', projectName = name.value.trim();
        const project = projects.find(entry => String(entry.id) === choice.value);
        if (isNew && !projectName) { $('[data-project-status]').textContent = 'Enter a Project name.'; return; }
        const doorIdMap = new Map(), newProjectDoors = [];
        for (const door of doors) {
          if (!door.doorAction || !selectionsForDoor(door.id).length || missingGlassBrackets(door.id).length || (!selectionsForDoor(door.id).some(item => item.rangeHandle === 'break-glass-call-points') && !door.manualOverrideConfirmed)) {
            $('[data-project-status]').textContent = 'Complete the Push or Pull choice and components for each door first.'; return;
          }
          const target = builderDoorFields.querySelector('[data-project-door-target="' + door.id + '"]');
          if (target?.value.startsWith('existing:')) {
            doorIdMap.set(door.id, target.value.slice('existing:'.length));
          } else {
            const projectDoor = { id: crypto.randomUUID(), name: door.name };
            newProjectDoors.push(projectDoor); doorIdMap.set(door.id, projectDoor.id);
          }
        }
        button.disabled = true; $('[data-project-status]').textContent = 'Saving your system…';
        try {
          const products = selected.map(item => {
            const door = doors.find(entry => entry.id === item.doorId);
            return { lineId: crypto.randomUUID(), productId: item.productId, variantId: item.variantId, quantity: item.quantity, title: item.title, productUrl: item.productUrl, doorId: doorIdMap.get(item.doorId), builderSource: 'access-control', builderPosition: item.position };
          });
          const url = isNew ? root.dataset.projectApi : root.dataset.projectApi + '/' + encodeURIComponent(project.id);
          const updatedDoors = isNew ? newProjectDoors : [...(project.doors || []), ...newProjectDoors];
          const payload = isNew
            ? { name: projectName, doors: updatedDoors, products }
            : { doors: updatedDoors, products: [...(project.products || []), ...products] };
          const response = await fetch(url, { method: isNew ? 'POST' : 'PATCH', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
          const data = await response.json().catch(() => ({})); if (!response.ok) throw new Error(data?.error?.message || 'Could not save the Project.');
          doors.forEach(door => {
            const savedDoor = updatedDoors.find(entry => String(entry.id) === String(doorIdMap.get(door.id)));
            if (savedDoor) door.name = savedDoor.name;
          });
          renderDoorList(); selectedView();
          dialog.close(); showCompletion('System saved to ' + (isNew ? projectName : project.name) + ' with ' + doors.length + (doors.length === 1 ? ' door.' : ' doors.'), false, true);
        } catch (error) { $('[data-project-status]').textContent = error.message || 'Could not save the Project.'; }
        finally { button.disabled = false; }
      });
    }
    syncDoorActionControl(); syncSceneButtons(); renderDoorList(); renderScene(); selectedView();
  };
  const start = () => document.querySelectorAll('[data-das-byo]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
